import React, { Component } from 'react'
import RBButton from '../controls/RBButton'
import Icon from '@material-ui/core/Icon'
import { goBack } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

class BackButton extends Component {
  render () {
    const iconColor = !this.props.secondary ? 'primary' : 'inherit'
    return (
      <RBButton
        className='backBenefitBtn'
        role='button'
        color
        label={this.props.label}
        icon={<Icon color={iconColor}>chevron_left</Icon>}
        onClick={this.props.goBack} />
    )
  }
}

// if no button type is passed, it will be primary by default; pass secondary if button is secondary
BackButton.propTypes = {
  secondary: PropTypes.bool
}

function mapStateToProps (state) {
  return state
}
function mapDispatchToProps (dispatch) {
  return bindActionCreators({ goBack }, dispatch)
}
const ConnectedBackButton = connect(mapStateToProps, mapDispatchToProps)(injectIntl(BackButton))

export default ConnectedBackButton



// WEBPACK FOOTER //
// ./src/controls/BackButton.js